/** Recortes puros sobre a lista de mensagens da conversa, para o painel mexer
 *  na cache sem esperar o servidor reler a conversa inteira. */
import type { MensagemDaConversa } from './api'

/** A lista sem o turno a que a mensagem `uuid` pertence: a resposta e a
 *  pergunta que a antecede, com o que houver entre as duas. É o mesmo recorte
 *  que o servidor faz ao apagar um turno, então a cache e o banco combinam. A
 *  mensagem pode ser a pergunta ou a resposta; uuid desconhecido devolve a
 *  lista como está. */
export function semTurno<M extends MensagemDaConversa>(mensagens: M[], uuid: string): M[] {
  const indice = mensagens.findIndex((m) => m.uuid === uuid)
  if (indice === -1) return mensagens
  let inicio = indice
  while (inicio > 0 && mensagens[inicio].papel !== 'usuario') inicio -= 1
  // Resposta sem pergunta antes dela sai sozinha.
  if (mensagens[inicio].papel !== 'usuario') inicio = indice
  let fim = indice + 1
  while (fim < mensagens.length && mensagens[fim].papel !== 'usuario') fim += 1
  return [...mensagens.slice(0, inicio), ...mensagens.slice(fim)]
}
